import { Theme, createTheme } from "@mui/material/styles";
import { buildComponents } from "./muiOverrides";
import { OpsTokens, TOKENS, ThemeMode } from "./tokens";

const buildPaletteCore = (t: OpsTokens) => ({
  primary: { main: t.blue500, dark: t.blue600, light: t.blue300, contrastText: t.textOnAction },
  secondary: { main: t.orange500, dark: t.orange600, contrastText: t.textOnAction },
  warning: { main: t.statusWarningFg },
  success: { main: t.statusSuccessFg },
  error: { main: t.statusDangerFg },
  info: { main: t.statusInfoFg },
  background: { default: t.surfaceApp, paper: t.surfaceCard },
  divider: t.borderDefault,
  text: { primary: t.textPrimary, secondary: t.textSecondary, disabled: t.textTertiary },
});

const buildTypography = (t: OpsTokens) => ({
  fontFamily: t.fontSans,
  fontSize: t.textBase,
  h1: { fontSize: 20, fontWeight: 700, letterSpacing: "-0.02em" },
  body1: { fontSize: t.textBase },
  button: { textTransform: "none" as const, fontWeight: 500 },
});

const NO_TOOLBAR_CHROME = { toolbar: { minHeight: 0 } };

export const createOpsTheme = (mode: ThemeMode): Theme => {
  const t = TOKENS[mode];

  return createTheme({
    components: buildComponents(t) as any,
    palette: { mode, ...buildPaletteCore(t) },
    typography: buildTypography(t),
    shape: { borderRadius: t.radiusControl },
    mixins: NO_TOOLBAR_CHROME,
  });
};

export const themes: Record<ThemeMode, Theme> = {
  light: createOpsTheme("light"),
  dark: createOpsTheme("dark"),
};
